import React, { useState } from 'react';
import { supabase } from '../../lib/supabaseClient';
import './AdminLogin.css';

export default function AdminLogin({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setError('Invalid credentials. Access denied.');
    } else {
      onLogin();
    }
    setLoading(false);
  };

  return (
    <div className="al">
      <div className="al__card">
        {/* Logo */}
        <div className="al__logo">
          <span className="al__logo-sa">SA</span>
          <span className="al__logo-sep">—</span>
          <span className="al__logo-dropped">DROPPED</span>
        </div>

        <p className="al__label">ADMIN ACCESS</p>
        <h1 className="al__title">Sign In</h1>
        <p className="al__sub">Restricted area. Authorised personnel only.</p>

        <form className="al__form" onSubmit={handleLogin}>
          <div className="al__field">
            <label className="al__field-label">Email</label>
            <input
              type="email"
              className="al__input"
              placeholder="email@gmail.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <div className="al__field">
            <label className="al__field-label">Password</label>
            <input
              type="password"
              className="al__input"
              placeholder="••••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>

          {error && <p className="al__error">{error}</p>}

          <button type="submit" className="al__btn" disabled={loading}>
            {loading ? 'Verifying...' : 'Enter Dashboard'}
          </button>
        </form>

        <p className="al__footer">SA Dropped Admin Portal · Restricted</p>
      </div>
    </div>
  );
}